import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {NavCategory, NavItems} from '../../nav-items/nav-items';
import {LOG_ENTRIES} from '../../../shared/log-helper/log-helper.service';
import {Log} from 'ng2-logger';

// logger
const log = Log.create(LOG_ENTRIES.drawer_menu.name);
log.color = LOG_ENTRIES.drawer_menu.color;


@Component({
  selector: 'app-drawer-menu',
  templateUrl: './drawer-menu.component.html',
  styleUrls: ['./drawer-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DrawerMenuComponent implements OnInit {
  items = {};
  menuCategory: NavCategory[] = [];

  @Input() menuKey = 'HOME';

  constructor(public navItems: NavItems) {

  }

  ngOnInit() {
    log.info(this.menuKey);
    this.items = this.navItems.getItems(this.menuKey);
    this.menuCategory = this.navItems.getCategories(this.menuKey);
    log.info('the menu items: ', this.items);
    log.info('the menu category: ', this.menuCategory);
  }

}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/drawer/drawer-menu/drawer-menu.component.ts